module.exports = __webpack_public_path__ + "static/media/planet-moon.4ccd1fcc.svg";